import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { HlmAvatarImports } from '@spartan-ng/helm/avatar';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-user-avatar',
  imports: [HlmAvatarImports],
  templateUrl: './user-avatar.component.html',
  host: { class: 'block' },
})
export class UserAvatarComponent implements OnInit {
  private readonly msal = inject(MsalService);
  private readonly router = inject(Router);
  readonly permissionService = inject(PermissionService);

  readonly userName = signal<string | null>(null);
  readonly userEmail = signal<string | null>(null);
  readonly open = signal(false);
  readonly dropdownPos = signal<{ x: number; y: number }>({ x: 0, y: 0 });

  readonly initials = computed(() => {
    const name = this.userName();
    if (!name) return null;
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    return parts[0][0].toUpperCase();
  });

  readonly avatarUrl = computed(() => {
    const email = this.userEmail();
    if (!email) return '';
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(this.userName() ?? email)}&background=E5DCCA&color=1B2A4A&size=32&font-size=0.4&bold=true`;
  });

  ngOnInit(): void {
    const account = this.msal.instance.getActiveAccount() ?? this.msal.instance.getAllAccounts()[0] ?? null;
    if (account) {
      this.userName.set(account.name ?? null);
      this.userEmail.set(account.username ?? null);
    }
  }

  toggle(event: MouseEvent): void {
    if (this.open()) {
      this.open.set(false);
      return;
    }
    const btn = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const dropdownWidth = 224;
    this.dropdownPos.set({
      x: btn.right - dropdownWidth,
      y: btn.bottom + 8,
    });
    this.open.set(true);
  }

  onAdminDashboard(): void {
    this.open.set(false);
    this.router.navigate(['/admin']);
  }
}
